// Helpers shared by the Contacts page and the admin tab.

export const CONTACT_KINDS = [
  { value: 'phone', label: 'Telefono' },
  { value: 'email', label: 'Email' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'telegram', label: 'Telegram' },
  { value: 'web', label: 'Sito web' },
];

const sanitizePhone = (raw) => raw.replace(/[\s\-().]/g, '');
const stripAt = (raw) => raw.trim().replace(/^@/, '');

const parseTelegramHandle = (raw) => {
  const v = (raw || '').trim();
  if (!v) return null;
  if (isSafeHttpsUrl(v)) {
    const match = v.match(/^https:\/\/t\.me\/([^\s/?#]+)/i);
    return match ? match[1] : null;
  }
  const withoutPrefix = v.replace(/^https?:\/\/(www\.)?t\.me\//i, '').replace(/^t\.me\//i, '');
  const handle = stripAt(withoutPrefix.split(/[/?#]/)[0]);
  return handle || null;
};

const isSafeHttpsUrl = (raw) => /^https:\/\/[^\s<>"']+$/i.test((raw || '').trim());

const ensureHttpsUrl = (raw) => {
  const v = (raw || '').trim();
  if (!v) return null;
  if (/^https:\/\//i.test(v)) return isSafeHttpsUrl(v) ? v : null;
  if (/^http:\/\//i.test(v)) return null;
  const candidate = `https://${v.replace(/^\/\//, '')}`;
  return isSafeHttpsUrl(candidate) ? candidate : null;
};

// Build the actionable href (tel:, mailto:, https://...) for a contact entry.
export const contactHref = ({ kind, value }) => {
  const v = (value || '').trim();
  if (!v) return null;
  switch (kind) {
    case 'phone':
      return `tel:${sanitizePhone(v)}`;
    case 'email':
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? `mailto:${v}` : null;
    case 'whatsapp': {
      if (isSafeHttpsUrl(v)) return v;
      const digits = sanitizePhone(v).replace(/^\+/, '');
      return digits ? `https://wa.me/${digits}` : null;
    }
    case 'instagram': {
      if (isSafeHttpsUrl(v)) return v;
      const handle = stripAt(v);
      return handle ? `https://instagram.com/${encodeURIComponent(handle)}` : null;
    }
    case 'telegram': {
      if (isSafeHttpsUrl(v)) {
        return /^https:\/\/t\.me\/[^\s/?#]+/i.test(v) ? v : null;
      }
      const handle = parseTelegramHandle(v);
      return handle ? `https://t.me/${encodeURIComponent(handle)}` : null;
    }
    case 'web':
    default:
      return ensureHttpsUrl(v);
  }
};

// Visual label shown next to the value (e.g. "@massimo" or "+39 388...")
export const contactDisplayValue = ({ kind, value }) => {
  const v = (value || '').trim();
  if (kind === 'instagram' && !v.startsWith('http')) {
    return `@${stripAt(v)}`;
  }
  if (kind === 'telegram' && !v.startsWith('http')) {
    const handle = parseTelegramHandle(v);
    return handle ? `@${handle}` : v;
  }
  return v;
};
